<template>
  <div class="underline-container">
    <a-input
      v-model:value="innerValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :status="error ? 'error' : ''"
      class="underline-input"
      @focus="isFocused = true"
      @blur="isFocused = false"
      @input="handleInput"
    />

    <div
      class="underline"
      :class="{
        active: isFocused || innerValue,
        error: error,
      }"
    />
  </div>

  <div v-if="error" class="error-text">
    {{ error }}
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";

interface Props {
  modelValue?: string | number;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "",
  disabled: false,
  error: "",
});

const emits = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const innerValue = ref(String(props.modelValue ?? ""));
const isFocused = ref(false);

watch(
  () => props.modelValue,
  (val) => {
    innerValue.value = String(val ?? "");
  }
);

const handleInput = (e: Event) => {
  const target = e.target as HTMLInputElement;

  innerValue.value = target.value;

  emits("update:modelValue", target.value);
};
</script>

<style scoped>
.underline-container {
  position: relative;
  width: 100%;
}

/* remove style mặc định antd */
:deep(.underline-input .ant-input) {
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding-left: 0;
  padding-right: 0;
  background: transparent;
}

/* remove hover */
:deep(.underline-input .ant-input:hover) {
  border: none !important;
  box-shadow: none !important;
}

/* remove focus */
:deep(.underline-input .ant-input:focus) {
  border: none !important;
  box-shadow: none !important;
}

.underline {
  width: 100%;
  height: 1px;
  background: #d9d9d9;
  transition: all 0.25s ease;
}

.underline.active {
  height: 2px;
  background: #1677ff;
}

.underline.error {
  background: #ff4d4f;
}

.error-text {
  margin-top: 4px;
  color: #ff4d4f;
  font-size: 12px;
}
</style>
<!-- 
<UnderlineInput
  v-model="username"
  placeholder="Nhập username"
/>
<UnderlineInput
  v-model="email"
  placeholder="Nhập email"
  error="Email không hợp lệ"
/> -->